import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    width: 350,
    justifyContent: "space-between",
    padding: 16,
    alignSelf: "center",
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    alignItems: "center",
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  authCodeInput: {
    marginLeft: 6,
  },

  cardTitleTxt: {
    fontWeight: "bold",
    fontSize: 18,
    color: "#077A97",
    textAlign: "center",
    textTransform: "uppercase",
  },

  containerBtns: {
    marginTop: 60,
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    alignSelf: "center",
  },

  btnCancelar: {
    fontFamily: "Poppins, sans-serif",
    padding: 4,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    alignSelf: "center",
    color: "#077A97",
    textTransform: "uppercase",
    flexWrap: "wrap",
    marginRight: 10,
  },

  btnConfimeSaque: {
    fontFamily: "Poppins, sans-serif",
    padding: 4,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    alignSelf: "center",
    color: "#fff",
    textTransform: "uppercase",
    flexWrap: "wrap",
  },

  loadingOverlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default styles;
